import { Component } from "@angular/core";
import { ModalBase } from "src/app/model/modal-base";

@Component({
    selector: 'app-nets-payment-3d-notification-modal',
    templateUrl: 'nets-payment-3d-notification-modal.component.html'
})
export class NetsPayment3dNotificationModalComponent extends ModalBase
{
    public constructor()
    {
        super();
    }
}
